module.exports = __webpack_public_path__ + "media/src/images/icon__magazinHappy3--dark-4174d102eb7d7108bff749122a808db2.svg";